import React from 'react';

export default () => (
    <div>
        <h1>Pepper Console, Version={process.env.SERVICE_VERSION || 'UNKNOWN'}</h1>
    </div>
);
